import css from '../ListingPageDescription.module.css';

const OrganizationField = ({ text }) => {
  return (
    <div className={css.fieldWithIconWrapper}>
      <Icon /> <div className={css.fieldWithIconText}>{text}</div>
    </div>
  );
};

const Icon = () => {
  return (
    <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="48" height="48" rx="24" fill="#E8F6F8" />
      <path
        d="M14 34H34"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.03 33.9898H15.01V24.8018C15.01 24.1961 15.5 23.6931 16.09 23.6931H19.03"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M20.03 19.5867H28.07C28.62 19.5867 29.07 20.0486 29.07 20.6133V34H19.03V20.6133C19.03 20.0486 19.48 19.5867 20.03 19.5867Z"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M25.0701 33.9897H32.9901V17.8517C32.9901 17.4206 32.7401 17.0202 32.3601 16.8457L26.6001 14.1047C25.8901 13.7659 25.0701 14.2895 25.0701 15.1005V19.5867"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8101 23.7033H25.0701"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8101 26.7933H25.0701"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M22.8101 29.8731H25.0701"
        stroke="#4E778A"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default OrganizationField;
